import React, {useCallback, useEffect} from 'react';
import {useDispatch} from "react-redux";
import {useSelector} from "react-redux";import NewsListItem from '../NewsListItem'
import {deleteItem,fetchNews,selectAll} from "./news_slice";
import {createSelector} from 'reselect'
import Spinner from '../Spinner'
import Error from "../Error";
import useHttp from "../../hooks/useHttp";
import '../styles/newsList.css'
import {CSSTransition,TransitionGroup} from "react-transition-group"
function NewsList(props) {
    const filteredNewsSelected = createSelector(
        (state)=>state.filter.activeFilter,
        selectAll,
        (filter,news)=>{
            if(filter==='all'){
                return news
            }else{
                return news.filter(i=>i.category===filter)
            }
    }
    )
    const filteredNews = useSelector(filteredNewsSelected)
    const filteredLoading = useSelector(state=>state.filteredLoading)
    const dispatch = useDispatch()
    const {request} = useHttp()

    // FETCHING NEWS //
    useEffect(()=>{
       dispatch(fetchNews())

    },[])
//======= DELETING ITEMS FROM DB json=======
   const deleteDB= useCallback((id)=>{
            request(` http://localhost:3001/news/${id}`, "DELETE")
                .then(()=>dispatch(deleteItem(id)))
                .catch((e)=>console.log(e))

    },[])

    ////////////////////////////////////
    if(filteredLoading==='true'){
        return <Spinner/>
    }else if(filteredLoading==='error'){
        return <Error/>
    }
    const renderNewList =(arr)=>{
        if(arr.length===0){
            return <CSSTransition timeout={500} classNames='item'>
                <h4 className='text-center mt-5'>News Do not Exist!</h4>
            </CSSTransition>
        }

       return  arr.map(({id,...props})=>{
            return (
                <CSSTransition key={id}
                timeout={500}
                classNames="item">
                    <NewsListItem  {...props} deleteItem={()=>deleteDB(id)}/>
                </CSSTransition>
            )
        }).reverse()
    }
    const element = renderNewList(filteredNews)


    return (

            <TransitionGroup component="ul">
                {element}
            </TransitionGroup>

    )

}

export default NewsList;